<template>
  <div :class="$.column">
    <div :class="$.header">
      <skeleton-item
        :style="{ height: '20px', width: '72px' }"
        type="bar"
      />
      <skeleton-item
        type="square"
        size="xs"
      />
    </div>
    <div :class="$.column_content">
      <card-skeleton
        v-for="(card, i) in data.cards"
        :key="`card_skeleton_${data.id}_${i}`"
        :type="card"
      />
      <div :class="$.content_footer">
        <skeleton-item
          type="square"
          size="sm"
        />
        <skeleton-item
          type="bar"
          :style="{ height: '12px', width: '80px'}"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonItem from '../../common/VueComponents/skeletons/skeletonItem.vue';
import CardSkeleton from './CardSkeleton.vue';

export default {
  name: 'ColumnSkeleton',
  components: {
    SkeletonItem,
    CardSkeleton
  },
  props: {
    data: {
      type: Object,
      default: {
        id: 'default',
        cards: []
      }
    }
  }
}
</script>

<style lang="less" module="$" src="../less/columnSkeleton.less"></style>
